<!-- part1学习潜力 -->
<template>
    <!-- 信息加工能力... 等 -->
    <div class="main_box main_box_part1">
        <!--		<P class="main_title"><span class="block"></span>{{normObj.name}}</P>-->
        <P class="main_title">{{index}}、{{normObj.name}}</P>
        <div class="main_norm_box">
            <div class="norm_box" :style="{width: normObj.score/200*692  + 'px'}" >
                <div class="norm_score">
                    <p class="score">{{normObj.score | toFixed(1)}}</p>
                </div>
                <div class="norm_block norm_block_part2" :style="{left: normData.l_norm/200*692 + 'px', width: (normData.r_norm-normData.l_norm)/200*692 + 'px' }" :title="normData.l_norm + '~' +normData.r_norm"></div>
            </div>
        </div>
        <p class="main_detail">你在{{normObj.name}}的潜能水平值为<span class="color3">{{normObj.score | toFixed(1)}}分</span>，水平为 <span :class="this.getColor(normObj.score )">{{this.getGrade(normObj.score )}}</span>，你超过了<span class="color3">{{normObj.percent * 100 | toFixed(1)}}%</span>的人。</p>
        <!--		<p class="main_remark"><span class="remark">备注</span>本测评潜能水平值范围0~200，{{normObj.name}}平均潜能水平值<span class="c_green">{{normObj.l_norm}}~{{normObj.r_norm}}</span>。</p>-->
        <P class="main_directions">{{comment}}</P>
    </div>
</template>
<script>
export default {
    name: 'page_part1_main',
    components: {  },
    props: {
        index: {},
        normData: {
            type: Object,//norm数组的其中一项
        },
        normObj: {
            type: Object,//norm数组的其中一项
            // required: true
        },
        comment: {
            type: String,//comment的类型解读
            // required: true
        }
    },
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        // [0,75)[75,92)[92,108)[108,125)[125,200]
        getColor(value) {
            if(value < 75) {
                return 'color1';
            }else if(value < 92) {
                return 'color2';
            }else if(value <= 108) {
                return 'color3';
            }else if(value <= 125) {
                return 'color4';
            }else {
                return 'color5';
            }
        },
        getGrade(value) {
            if(value < 75) {
                return '低';
            }else if(value < 92) {
                return '较低';
            }else if(value <= 108) {
                return '中等';
            }else if(value <= 125) {
                return '较高';
            }else {
                return '高';
            }
        }
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
</style>
